import { jsx as o } from "react/jsx-runtime";
import L from "classnames";
import c from "../../utils/colors.js";
import { Svg as l, GElement as s, Path as f } from "./Elements.js";
const C = "matrix(1,0,0,1,0,-4)", p = "M7.5,17.333L7.5,13.167C7.5,12.247 8.247,11.5 9.167,11.5L13.333,11.5L7.5,17.333ZM13.333,4L1.667,4C0.747,4 0,4.748 0,5.667L0,17.333C0,18.253 0.747,19 1.667,19L7.5,19C8.183,19 9.029,18.649 9.512,18.167L14.167,13.512C14.65,13.028 15,12.182 15,11.5L15,5.667C15,4.748 14.253,4 13.333,4Z", G = ({
  className: r = "",
  clipRule: t = "evenodd",
  fill: n = c.blueGrey,
  fillRule: d = "evenodd",
  strokeLinejoin: m = "round",
  strokeMiterlimit: i = "2",
  viewBox: a = "0 0 15 15",
  focusable: e
}) => /* @__PURE__ */ o(
  l,
  {
    className: L({ [r]: !!r }),
    clipRule: t,
    fill: n,
    fillRule: d,
    strokeLinejoin: m,
    strokeMiterlimit: i,
    viewBox: a,
    focusable: !!e,
    "aria-hidden": !e,
    children: /* @__PURE__ */ o(s, { transform: C, children: /* @__PURE__ */ o(f, { d: p }) })
  }
);
export {
  G as default
};
